import visit from 'unist-util-visit';
export default function externalLinks({ test, internalProps = {}, externalProps = {
    target: '_blank',
    rel: 'nofollow noopener noreferrer',
}, }) {
    return {
        rehype: (p) => p.use(() => (tree) => {
            visit(tree, 'element', (node) => {
                var _a;
                if (node.tagName !== 'a' || !((_a = node.properties) === null || _a === void 0 ? void 0 : _a.href))
                    return;
                const href = node.properties.href;
                if (!/https?:\/\//.test(href))
                    return; // only handle http and https
                Object.assign(node.properties, test(href) ? externalProps : internalProps);
            });
        }),
    };
}
